import { useState } from "react";
import { X } from "lucide-react";
import { MEDIA } from "../lib/constants";

export default function Portfolio() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative bg-[#F8FAFC] py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 md:mb-20">
          <div className="lg:col-span-7">
            <div className="eyebrow text-[#1E40AF] mb-4">
              <span className="inline-block w-8 h-[2px] bg-[#1E40AF] align-middle mr-3" />
              02 · Seneste projekt
            </div>
            <h2
              data-testid="portfolio-heading"
              className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0F213A] leading-[1.05]"
            >
              Eksklusiv træterrasse{" "}
              <span className="text-[#1E40AF]">med spa.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-[#475569] text-base leading-relaxed">
              Vi leverer finish i topklasse. Her ses en nyligt færdiggjort
              træterrasse bygget med præcision — skjulte hængsler, rene linjer
              og tidløse materialer.
            </p>
          </div>
        </div>

        {/* Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-5">
          {MEDIA.portfolio.map((src, i) => (
            <button
              key={src}
              data-testid={`portfolio-image-${i}`}
              onClick={() => setActive(i)}
              className={`img-reveal relative group bg-[#0F213A] ${
                i === 0
                  ? "md:col-span-4 md:row-span-2 h-72 md:h-[560px]"
                  : "md:col-span-2 h-64 md:h-[270px]"
              }`}
            >
              <img
                src={src}
                alt={`Træterrasse detalje ${i + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F213A]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-4 left-4 text-white text-xs uppercase tracking-[0.25em] font-bold opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
                Detalje · {String(i + 1).padStart(2, "0")}
              </div>
            </button>
          ))}
        </div>

        {/* Caption */}
        <div className="mt-10 border-t border-[#E2E8F0] pt-6 flex flex-col sm:flex-row justify-between gap-4 text-sm">
          <div className="text-[#475569]">
            <span className="text-[#0F213A] font-bold">Materiale:</span>{" "}
            Hårdttræ · sortmalet facade · stålbeslag
          </div>
          <div className="text-[#475569]">
            <span className="text-[#0F213A] font-bold">Udført:</span> JL Service ·{" "}
            {new Date().getFullYear()}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {active !== null && (
        <div
          data-testid="portfolio-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[100] bg-[#0F213A]/95 flex items-center justify-center p-4 md:p-10 cursor-zoom-out"
        >
          <button
            onClick={() => setActive(null)}
            data-testid="lightbox-close"
            className="absolute top-5 right-5 text-white p-2 hover:bg-white/10"
            aria-label="Luk"
          >
            <X size={28} />
          </button>
          <img
            src={MEDIA.portfolio[active]}
            alt="Portfolio forstørrelse"
            className="max-h-[90vh] max-w-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
